import contestacionService from '../services/contestacion.js';

export const useContestaciones = () => {

    const setGuardarContestacion = (contestacionAGuardar) => contestacionService.setGuardarContestacion(contestacionAGuardar);

    const getPreguntaAnterior = (idUsuario, idPregunta, idEje) => contestacionService.getPreguntaAnterior(idUsuario, idPregunta, idEje);

    const reiniciarEje = (usuario, idEje) => contestacionService.reiniciarEje(usuario, idEje);

    return { setGuardarContestacion, getPreguntaAnterior, reiniciarEje };
}